export default __webpack_public_path__ + "static/media/contact.6ebaea36.png";